export class AmountSelection {
    customAmountInput: HTMLInputElement;
    radioInputs: HTMLInputElement[];
    inputBlurHandlers: Function[];
    radioSelectHandlers: Function[];
    customAmountRadio?: HTMLInputElement;

    constructor(customAmountInput: HTMLInputElement, radioInputs: HTMLInputElement[]) {
        this.customAmountInput = customAmountInput;
        this.radioInputs = radioInputs;
        this.inputBlurHandlers = [];
        this.radioSelectHandlers = [];
        this.customAmountInput.addEventListener('blur', this.inputBlurred.bind(this));
    }

    on(event: string, handler: Function) {
        switch (event) {
            case "inputBlur":
                return this.inputBlurHandlers.push(handler);
            case "radioSelect":
                return this.radioSelectHandlers.push(handler);
        }
    }

    inputBlurred() {
        const newValue = parseInt(this.customAmountInput.value);
        if (newValue <= 0) {
            this.customAmountInput.value = null;
        }
        if (this.inputBlurHandlers) {
            this.inputBlurHandlers.forEach(handler => {
                setTimeout(handler.bind(this), 0);
            })
        }
    }
}